import globalsObject from "./globalsObject";
export class WEbGLErrorReason {
    errorCode;
    os;
    browser;
    isSpecific;

    constructor(clientData){
        this.errorCode =  "konf_webglError_Generic";
        this.os =  clientData.os + " " + clientData.osVersion;
        this.browser =  clientData.browser + " " + clientData.browserVersion;
        this.isSpecific =  false;
    }
}

export class WebGLErrorHandler {



    public static handleWebGLError(lang, knownReason?) {
        let reason = WebGLErrorHandler.webGLFailReason();
        reason.lang = lang;
        if (typeof(knownReason) === "string") {
            reason.errorCode = knownReason;
        }

        reason.product = globalsObject.infoFromGetParameters.productInfo.product.webInZielsprache;
        reason.sport = globalsObject.infoFromGetParameters.sportFuerProduktauswahl.webInZielsprache;
        $.post("noWebGLContextInline.php", {data:JSON.stringify(reason)},
            function(result) {
                $("#nav-user").remove();
                $("#site-header").remove();
                $("#divKonfi").replaceWith(result);
            }
        );
        // $("<form action = 'noWebGLContext.php' method='post' style='display:none;'><input name='data' value='" + JSON.stringify(reason) + "'></form>").appendTo("body").submit();

    }

    private static getIEWebGLFailReason(result, clientData, badWinVersions) {
        if (badWinVersions.indexOf(clientData.os) > -1) {
            result.errorCode = "konf_webglError_IE_badWin";
            result.isSpecific = true;
        }
        if (clientData.browserVersion < 11) {
            result.errorCode = "konf_webglError_IE_oldVersion";
            result.isSpecific = true;

        }
        return result;
    }

    private static getChromeWebGLFailReason(result, clientData, badWinVersions) {
        if (clientData.os === "Mac Os X" && parseInt(clientData.osVersion, 10) < 6) {
            result.errorCode = "konf_webglError_Chrome_oldMacOS";
            result.isSpecific = true;
            return result;
        }
        if (clientData.os === "Mac Os") {
            result.errorCode = "konf_webglError_Chrome_oldMacOS";
            result.isSpecific = true;
            return result;
        }
        if (clientData.browserVersion.split(".")[0] < 18) {
            result.errorCode = "konf_webglError_Chrome_oldVersion";
            result.isSpecific = true;
            return result;
        }
        if (clientData.os === "Windows" && ["XP", "Vista", "2000"].concat(badWinVersions).indexOf(clientData.osVersion) > -1) {
            result.errorCode = "konf_webglError_Chrome_badWin";
            result.isSpecific = true;
            return result;
        }
        if (clientData.os === "Android") {
            result.errorCode = "konf_webglError_Chrome_Android";
            result.isSpecific = true;
            return result;
        }
        return result;
    }

    private static getFirefoxWebGLFailReason(result, clientData, badWinVersions) {
        if (clientData.os === "Mac Os X" && parseInt(clientData.osVersion, 10) < 6) {
            result.errorCode = "konf_webglError_Firefox_oldMacOs";
            result.isSpecific = true;
            return result;
        }
        if (clientData.os === "Mac Os") {
            result.errorCode = "konf_webglError_Firefox_oldMacOs";
            result.isSpecific = true;
            return result;
        }
        if (badWinVersions.indexOf(clientData.osVersion) > -1) {
            result.errorCode = "konf_webglError_Firefox_badWin";
            result.isSpecific = true;
            return result;
        }
        if (clientData.osVersion === "XP") {
            result.errorCode = "konf_webglError_Firefox_XP";
            return result;
        }
        return result;
    }

    private static getSafariWEbGLFailreason(result, clientData) {
        if (clientData.browserVersion < 7.1) {
            result.errorCode = "konf_webglError_Safari_oldVersion";
            result.isSpecific = true;

        }
        return result;
    }

    private static getOperaWeGLFailReason(result, clientData) {
        if (clientData.browserVersion < 12) {
            result.isSpecific = true;
            result.errorCode = "konf_webglError_Opera_oldVersion";

        }
        return result;
    }

    public static webGLFailReason() {
        const clientData = WebGLErrorHandler.testOs(),
            badWinVersions = ["3.11", "95", "ME", '98', 'CE'],

            result = new WEbGLErrorReason(clientData);

        if (!window.WebGLRenderingContext) {
            result.errorCode = "konf_webglError_Generic_oldVersion";
        }

        if (clientData.os === "iOS" && parseInt(clientData.osVersion, 10) < 8) {
            result.errorCode = "konf_webglError_badIOS";
            result.isSpecific = true;
            return result;
        }

        switch (clientData.browser) {
            case 'Microsoft Internet Explorer' : //MSIE 11 wird hier nicht erfasst!
                return WebGLErrorHandler.getIEWebGLFailReason(result, clientData, badWinVersions);
            case "Chrome":
                return WebGLErrorHandler.getChromeWebGLFailReason(result, clientData, badWinVersions);
            case "Safari" :
                return WebGLErrorHandler.getSafariWEbGLFailreason(result, clientData);
            case "Opera":
                WebGLErrorHandler.getOperaWeGLFailReason(result, clientData);
                break;
            case "Firefox":
                return WebGLErrorHandler.getFirefoxWebGLFailReason(result, clientData, badWinVersions);
            default:
        }

        return result;
    }



    /**
     * JavaScript Client Detection
     * (C) viazenetti GmbH (Christian Ludwig)
     */
    // noinspection OverlyComplexFunctionJS, FunctionTooLongJS
    private static testOs() {
        let unknown = '-',
            browser, version, nameOffset, verOffset, ix,
            mobile, cookieEnabled, os, osVersion, id, cs;

        //browser
        const nVer = navigator.appVersion;
        const nAgt = navigator.userAgent;
        browser = navigator.appName;
        version = parseFloat(navigator.appVersion).toString();
        //majorVersion = parseInt(navigator.appVersion, 10);


        // Opera
        if ((verOffset = nAgt.indexOf('Opera')) !== -1) {
            browser = 'Opera';
            version = nAgt.substring(verOffset + 6);
            if ((verOffset = nAgt.indexOf('Version')) !== -1) {
                version = nAgt.substring(verOffset + 8);
            }
        }
        // MSIE
        else if ((verOffset = nAgt.indexOf('MSIE')) !== -1) {
            browser = 'Microsoft Internet Explorer';
            version = nAgt.substring(verOffset + 5);
        }
        // Chrome
        else if ((verOffset = nAgt.indexOf('Chrome')) !== -1) {
            browser = 'Chrome';
            version = nAgt.substring(verOffset + 7);
        }
        // Safari
        else if ((verOffset = nAgt.indexOf('Safari')) !== -1) {
            browser = 'Safari';
            version = nAgt.substring(verOffset + 7);
            if ((verOffset = nAgt.indexOf('Version')) !== -1) {
                version = nAgt.substring(verOffset + 8);
            }
        }
        // Firefox
        else if ((verOffset = nAgt.indexOf('Firefox')) !== -1) {
            browser = 'Firefox';
            version = nAgt.substring(verOffset + 8);
        }
        // MSIE 11+
        else if (nAgt.indexOf('Trident/') !== -1) {
            browser = 'Microsoft Internet Explorer';
            version = nAgt.substring(nAgt.indexOf('rv:') + 3);
        }
        // Other browsers
        else if ((nameOffset = nAgt.lastIndexOf(' ') + 1) < (verOffset = nAgt.lastIndexOf('/'))) {
            browser = nAgt.substring(nameOffset, verOffset);
            version = nAgt.substring(verOffset + 1);
            if (browser.toLowerCase() === browser.toUpperCase()) {
                browser = navigator.appName;
            }
        }
        // trim the version string
        if ((ix = version.indexOf(';')) !== -1) {
            version = version.substring(0, ix);
        }
        if ((ix = version.indexOf(' ')) !== -1) {
            version = version.substring(0, ix);
        }
        if ((ix = version.indexOf(')')) !== -1) {
            version = version.substring(0, ix);
        }

        const majorVersion = parseInt(version, 10);
        if (isNaN(majorVersion)) {
            version = parseFloat(navigator.appVersion).toString();
            //majorVersion = parseInt(navigator.appVersion, 10);
        }

        // mobile version
        mobile = /Mobile|mini|Fennec|Android|iP(ad|od|hone)/.test(nVer);

        // cookie
        cookieEnabled = !!(navigator.cookieEnabled);

        if (typeof (navigator.cookieEnabled) === 'undefined' && !cookieEnabled) {
            document.cookie = 'testcookie';
            cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
        }

        // system
        os = unknown;
        const clientStrings = [
            {s: 'Windows 3.11', r: /Win16/},
            {s: 'Windows 95', r: /(Windows 95|Win95|Windows_95)/},
            {s: 'Windows ME', r: /(Win 9x 4\.90|Windows ME)/},
            {s: 'Windows 98', r: /(Windows 98|Win98)/},
            {s: 'Windows CE', r: /Windows CE/},
            {s: 'Windows 2000', r: /(Windows NT 5\.0|Windows 2000)/},
            {s: 'Windows XP', r: /(Windows NT 5\.1|Windows XP)/},
            {s: 'Windows Server 2003', r: /Windows NT 5\.2/},
            {s: 'Windows Vista', r: /Windows NT 6\.0/},
            {s: 'Windows 7', r: /(Windows 7|Windows NT 6\.1)/},
            {s: 'Windows 8.1', r: /(Windows 8\.1|Windows NT 6\.3)/},
            {s: 'Windows 8', r: /(Windows 8|Windows NT 6\.2)/},
            {s: 'Windows NT 4.0', r: /(Windows NT 4\.0|WinNT4\.0|WinNT|Windows NT)/},
            {s: 'Windows ME', r: /Windows ME/},
            {s: 'Android', r: /Android/},
            {s: 'Open BSD', r: /OpenBSD/},
            {s: 'Sun OS', r: /SunOS/},
            {s: 'Linux', r: /(Linux|X11)/},
            {s: 'iOS', r: /(iPhone|iPad|iPod)/},
            {s: 'Mac OS X', r: /Mac OS X/},
            {s: 'Mac OS', r: /(MacPPC|MacIntel|Mac_PowerPC|Macintosh)/},
            {s: 'QNX', r: /QNX/},
            {s: 'UNIX', r: /UNIX/},
            {s: 'BeOS', r: /BeOS/},
            {s: 'OS/2', r: /OS\/2/},
            {s: 'Search Bot', r: /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/}
        ];
        for (id in clientStrings) {
            if (clientStrings.hasOwnProperty(id)) {
                cs = clientStrings[id];
                if (cs.r.test(nAgt)) {
                    os = cs.s;
                    break;
                }
            }
        }



        if (/Windows/.test(os)) {

            os = 'Windows';
        }

        switch (os) {
            case 'Mac OS X':
                osVersion = (/Mac OS X (10[._\d]+)/.exec(nAgt) as RegExpExecArray)[1];
                break;

            case 'Android':
                osVersion = (/Android ([._\d]+)/.exec(nAgt) as RegExpExecArray)[1];
                break;

            case 'iOS':
                osVersion = /OS (\d+)_(\d+)_?(\d+)?/.exec(nVer);
                osVersion = osVersion[1] + '.' + osVersion[2] + '.' + (osVersion[3] | 0);
                break;
            default:
                osVersion = "unknown OS";
        }
        return {
            // screen: screenSize,
            browser: browser,
            browserVersion: version,
            mobile: mobile,
            os: os,
            osVersion: osVersion,
            cookies: cookieEnabled
        };
    }
}
